/**
 * UranIA PA — Root route `/` redirect.
 *
 * Niente landing page: la home reindirizza automaticamente a
 * ``/dashboard`` se l'utente è autenticato, altrimenti a ``/login``.
 */

import { useEffect } from 'react';
import { createRoute, useNavigate } from '@tanstack/react-router';
import type { JSX } from 'react';

import { selectIsAuthenticated, useAuthStore } from '../lib/auth/auth-store.ts';
import { Route as RootRoute } from './__root.tsx';

function HomeRedirect(): JSX.Element {
  const isAuthenticated = useAuthStore(selectIsAuthenticated);
  const navigate = useNavigate();

  useEffect(() => {
    void navigate({
      to: isAuthenticated ? '/dashboard' : '/login',
      replace: true,
    });
  }, [isAuthenticated, navigate]);

  return <div data-testid="home-redirecting" aria-hidden="true" />;
}

export const Route = createRoute({
  getParentRoute: () => RootRoute,
  path: '/',
  component: HomeRedirect,
});
